/**
 * Returns {@code true} if there is no double value strictly between the
 * arguments or the relative difference between them is less than or equal
 * to the given tolerance. Returns {@code false} if either of the arguments
 * is NaN.
 *
 * @param x First value.
 * @param y Second value.
 * @param epsilon Amount of allowed relative error.
 * @return {@code true} if the values are two adjacent floating point
 * numbers or they are within range of each other.
 */
export const numberEqualsWithRelativeTolerance = (x, y, epsilon) => {
    if (x === y) {
        return true;
    }
    const absoluteMax = Math.max(Math.abs(x), Math.abs(y));
    const relativeDifference = Math.abs((x - y) / absoluteMax);
    return relativeDifference <= epsilon;
};
